// Identidade pseudónima de uma instalação DOMUS, exclusivamente neste navegador.
// Nunca utiliza MAC, IP, GPS, fingerprint, dispositivos próximos ou cookies de terceiros.
// O identificador NÃO é uma credencial e não autoriza qualquer acesso aos dados da família.
import {localGet,localSet} from './localFamilyStore'
const KEY='domus:installation:v1'
const uuid=()=>{if(!globalThis.crypto?.randomUUID)throw Error('Identificação segura indisponível');return crypto.randomUUID()}
const validId=x=>typeof x==='string'&&/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(x)
export async function getInstallation(){
 const saved=await localGet(KEY)
 return saved&&saved.version===1&&validId(saved.id)?saved:null
}
export async function initInstallation(){
 const existing=await getInstallation()
 if(existing)return existing
 const record={version:1,id:uuid(),createdAt:new Date().toISOString(),bindings:{}}
 await localSet(KEY,record)
 return record
}
// Um vínculo é apenas um marcador LOCAL de conveniência, nunca prova de pertença.
// A associação requer uma sessão familiar reconhecida e ação explícita do utilizador.
export async function linkInstallation({userId,familyId}){
 if(!validId(userId)||!validId(familyId))throw Error('É necessária uma sessão familiar válida')
 const installation=await initInstallation()
 const bindings={...installation.bindings,[userId]:{familyId,linkedAt:new Date().toISOString()}}
 const updated={...installation,bindings}
 await localSet(KEY,updated)
 return updated
}
export async function unlinkInstallation(userId){
 if(!validId(userId))throw Error('Identidade de utilizador inválida')
 const installation=await getInstallation()
 if(!installation)return null
 const bindings={...installation.bindings};delete bindings[userId]
 const updated={...installation,bindings}
 await localSet(KEY,updated)
 return updated
}
export async function readFamilyBinding({userId,familyId}){
 if(!validId(userId)||!validId(familyId))return null
 const installation=await getInstallation()
 const match=installation?.bindings?.[userId]
 return match?.familyId===familyId?{installationId:installation.id,linkedAt:match.linkedAt}:null
}
